/* unplugin-vue-components disabled */import { render } from "./CollectUserAuth.vue?vue&type=template&id=4e6b7b4c&scoped=true"
import script from "./CollectUserAuth.vue?vue&type=script&lang=js"
export * from "./CollectUserAuth.vue?vue&type=script&lang=js"

import "./CollectUserAuth.vue?vue&type=style&index=0&id=4e6b7b4c&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/mianjuyry-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e6b7b4c"]])

export default __exports__